import { ViewIds } from '@ardoq/api-types';
import {
  firstShadowSLayer,
  secondShadowSLayer,
  ShadowLayer,
} from '@ardoq/design-tokens';
import { logError } from '@ardoq/logging';
import { PaneLocation } from 'streams/views/mainContent/types';
import { CanvasRenderingContext } from './canvasRendering/types';

type LogVisualizationErrorArgs = {
  viewId: ViewIds;
  location: PaneLocation;
  isViewpointMode?: boolean;
};

export const logVisualizationError = ({
  viewId,
  location,
  isViewpointMode,
}: LogVisualizationErrorArgs) => {
  logError(new Error('Visualization error'), null, {
    viewId,
    location,
    isViewpointMode,
  });
};

export const shadowLayers = [firstShadowSLayer, secondShadowSLayer];

export const fillAndStrokeWithShadowLayers = (
  ctx: CanvasRenderingContext,
  layers: readonly ShadowLayer[],
  fillStyle: string,
  strokeStyle: string | null,
  buildPath: () => void
) => {
  for (const sh of layers) {
    ctx.save();
    ctx.shadowOffsetX = parseFloat(sh.offsetX);
    ctx.shadowOffsetY = parseFloat(sh.offsetY);
    ctx.shadowBlur = parseFloat(sh.blur);
    ctx.shadowColor = sh.color;

    buildPath();
    ctx.fillStyle = fillStyle;
    ctx.fill();
    ctx.restore();
  }

  buildPath();
  ctx.fillStyle = fillStyle;
  ctx.fill();
  if (strokeStyle) {
    ctx.strokeStyle = strokeStyle;
    ctx.stroke();
  }
};
